import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const removeCompany = ({ frameworkAgreementId, facId }) => {
  return axios.delete(`/api/framework_agreements/${frameworkAgreementId}/companies/${facId}`);
};

export const useRemoveCompany = (type, onCompanyRemoval) => {
  const { enqueueSnackbar } = useSnackbar();
  const snackMessage =
    type === 'buyer'
      ? 'Buyer successfully removed from the framework agreement'
      : 'Supplier successfully removed from the framework agreement';

  return useMutation({
    mutationFn: removeCompany,
    onSuccess: () => {
      enqueueSnackbar(snackMessage, {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      onCompanyRemoval();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
